import { map } from 'lodash'

const prepareShow = living => {
  return living
}

const prepareSave = living => {
  return living
}

export default {
  prepareSave,
  prepareShow,
  afterCreated () {
    this.$toast.success('Residente incluido com sucesso.')
    return this.$router.push({name: 'tenant.livings.index'})
  },
  afterUpdated () {
    this.$toast.success('Residente alterado com sucesso.')
    return this.$router.push({name: 'tenant.livings.index'})
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  /** Retornando as torres das uniades do dweller */
  getTowersDweller () {
    this.$http.get('/v1/dweller/towers/search')
      .then(({data}) => {
        const towers = map(data, function (item) {
          return {
            id: item.id,
            number: item.number + ' - ' + item.name
          }
        })
        this.dwellerTowers = towers
      })
  },
  /** Retornando as unidades da torre selecionada */
  selectUnitsTower (tower) {
    if (typeof tower === 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower.id)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }

    if (typeof tower !== 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }
  },
  getTowers () {
    this.$http.get('/v1/dweller/search/tower')
      .then((data) => {
        this.dwellerTowers = data.data
      })
  },
  livingStatus (status) {
    if (status) {
      this.living.status = false
    } else {
      this.living.status = true
    }
  },
  livingStatusAccesss (status) {
    if (status) {
      this.living.access = false
    } else {
      this.living.access = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/livings/form/resources/methods.js